import Component from 'gia/Component'
import _each from 'lodash.foreach'
//import Flickity from 'flickity'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Issue extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      title: null,
      slider: null
    }

  }

  mount() {

    const words = new SplitText(this.ref.title, {
      type: "words,chars",
      wordsClass: 'word',
      charsClass: 'ch'
    })
    words.words.forEach((item, j) => {
      // $(item).contents().wrap('<div class="new"/>')
      item.style = `--word-index: ${++this.i}`
    })

    

     let tl = gsap.timeline({
       // yes, we can add it to an entire timeline!
       scrollTrigger: {
         trigger: this.element,
         start: "top top-=10%", // when the top of the trigger hits the top of the viewport
         markers: false,
         end: "top top-=50%", // end after scrolling 500px beyond the start
         scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar,


       }
     });

     tl.to(words.chars, {
       duration: .31,
       opacity: 0,
       scaleY: 0,
       ease: "power4.out",
       stagger: 0.01
     });



    this.element.classList.add('loaded')
}



  unmount() {




  }


}

module.exports = Issue
